import React, {useRef, useState} from "react"
import {DefaultTablePagination, Popconfirm, Table, Tooltip} from "../../../components/Elements/appUtils"
import {patientPurchaseFxn} from "../actions/patients";
import moment from "moment";
import {customAxios as axios, getToken} from "../../../request";
import {getProductReport} from "../../purchase/api";

const PatientPurchaseList = (props) => {
    let tableRef = useRef()

    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [saleDetails, setSaleDetails] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.customerId = props.customerId;
            params.sortField = "_id"
            params.sortOrder = "descend"
            let resp = await patientPurchaseFxn(params);
            resolve(resp)
        })
    }
    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Vendor",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.name}</span>,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
        },
        {
            title: "Date of Receiving product",
            dataIndex: "purchaseDate",
            key: "purchaseDate",
            render: (text) => <span>{moment(text).format("DD-MMM-YYYY")}</span>,
        },
        {
            title: "State",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.state}</span>,
        },
        {
            title: "Total Quantity",
            dataIndex: "quantity",
            key: "quantity",
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text) => <span>Rs. {text}</span>,
        },
        {
            title: "Paid Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            render: (text) => <span>Rs. {text}</span>,
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
            render: (text) => <span>Rs. {text}</span>,
        }
    ];

    const fetchPurchaseDetails = async (purchaseId) => {
        if (!purchaseId || saleDetails[purchaseId]) {
            return
        }

        setLoadingDetails(prev => ({...prev, [purchaseId]: true}))
        try {
            let config = {
                params: {purchaseId: purchaseId},
                ...(await getToken()),
            };
            const response = await axios.get(getProductReport(), config);

            setSaleDetails(prev => ({...prev, [purchaseId]: response.data?.data || []}))
        } catch (error) {
            setSaleDetails(prev => ({...prev, [purchaseId]: []}))
        } finally {
            setLoadingDetails(prev => ({...prev, [purchaseId]: false}))
        }
    }
    const expandedRowRender = (record) => {
        const purchaseId = record._id;
        const details = saleDetails[purchaseId] || [];
        const loading = loadingDetails[purchaseId];

        if (loading) {
            return <div style={{padding: 16}}>Loading purchase details...</div>
        }

        if (!details.length) {
            return <div style={{padding: 16}}>No sale details found.</div>
        }


        return (
            <div style={{padding: 16, overflowX: 'auto'}}>
                <table className="table table-bordered table-xs mb-0">
                    <thead>
                    <tr>
                        <td>Sr no.</td>
                        <td>Product Name</td>
                        <td>Report Type</td>
                        <td>Mfg Date</td>
                        <td>Exp Date</td>
                        <td>Batch</td>
                        <td>Qty.</td>
                        <td>Sale Price</td>
                        <td>Price</td>
                        <td>Dis Amt.</td>
                        <td>Taxable Amt.</td>
                        <td>CGST Amt.</td>
                        <td>SGST Amt.</td>
                        <td>Net Amt.</td>
                    </tr>
                    </thead>
                    <tbody>
                    {details.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.productName}</td>
                            <td>{item.reportType}</td>
                            <td>{item.manufacturingDate}</td>
                            <td>{item.expiryDate}</td>
                            <td>{item.batchNo}</td>
                            <td>{item.quantity}</td>
                            <td>Rs. {item.salePrice}</td>
                            <td>Rs. {item.price}</td>
                            <td>
                                Rs. {item.discountAmount} (
                                {item.discount}%)
                            </td>
                            <td>Rs. {item.taxableAmount}</td>
                            <td>Rs. {item.cgstAmount}</td>
                            <td>Rs. {item.sgstAmount}</td>
                            <td>Rs. {item.netAmount}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div>
            <Table
                apiRequest={apiRequest}
                columns={columns}
                ref={tableRef}
                position={"top"}
                expandable={{
                    expandedRowKeys,
                    onExpandedRowsChange: (keys) => {
                        setExpandedRowKeys(keys || []);
                        if (keys && keys.length) {
                            keys.forEach((key) => fetchPurchaseDetails(key));
                        }
                    },
                    expandedRowRender: expandedRowRender,
                }}
                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}

            />
        </div>
    )
}
export default PatientPurchaseList